import {
  CONTROLS,
  type BindingKey,
  type BoundField,
  type FormControlKey,
  type ModuleField,
} from "shared"

/**
 * How the canvas makes a field. The state the canvas works on lives in
 * moduleState.ts.
 */

/** A field of this control, named for it. */
export const newField = (control: FormControlKey): ModuleField =>
  CONTROLS[control].create(crypto.randomUUID())

/** A field bound to this binding, called what it is bound to. */
export const newBoundField = (binding: BindingKey): BoundField => ({
  id: crypto.randomUUID(),
  binding,
})
